<template>
  <!-- 管理员页面 -->
  <div>
    <!-- 1.面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        系统管理
      </el-breadcrumb-item>
      <el-breadcrumb-item>字典管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 2.搜索框 -->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输查询信息（用空格分隔），支持模糊搜索" v-model="query">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryDic()"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 3.表格 -->
      <el-table :data="dic" style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="200"></el-table-column>
        <el-table-column prop="value" label="值" width="180"></el-table-column>
        <el-table-column prop="desc" label="描述" width="350"> </el-table-column>
      </el-table>
      <!-- 4.分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
    <el-card>
      <h1>请选择申报截至日期，以便判断申报者年龄是否符合要求</h1>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" format="yyyy-MM-dd">
      </el-date-picker>
      <el-button type="primary" @click.prevent="changeEndDate()">确定修改</el-button>
    </el-card>

    <el-card>
      <h1>请输入研究计划字数限制</h1>
      <el-input style="width: 100px;" v-model="TotalWrods"></el-input>
      <el-button type="primary" @click.prevent="changeTotalWrods()">确定修改</el-button>
    </el-card>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        query: "", //查询信息
        dic: [],
        //分页
        currentPage: 1,
        page_size: 10,
        total: 0,
        // 截止日期设置
        endDate: '',
        // 研究计划字数限制
        TotalWrods: 0,
      }
    },
    created() {
      this.getDic(1, 10)
    },
    methods: {
      //获取列表
      async getDic(page, page_size) {
        const res = await this.axios.get(
          `/sysDic/?page=${page}&page_size=${page_size}`
        )
        if (res.status === 200) {
          this.dic = res.data.results
          this.total = res.data.count
          for (let i = 0; i < this.dic.length; i++) {
            if (this.dic[i].name == "申报截至日期") {
              this.endDate = this.dic[i].value
            }
            if (this.dic[i].name == "研究计划字数限制") {
              this.TotalWrods = this.dic[i].value
            }
          }
        } else {
          this.$message.warning("错误")
        }
      },
      //分页
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.page_size = val
        this.getDic(this.currentPage, this.page_size)
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getDic(this.currentPage, this.page_size)
      },

      // 查询
      async queryDic() {
        const res = await this.axios.get(
          `/opLog/?page=${this.currentPage}&page_size=${this.page_size}&search=${this.query}`
        )
        if (res.status === 200) {
          this.dic = res.data.results
          this.total = res.data.count
          // console.log(res)
        } else {
          this.$message.warning("错误")
        }
      },

      //修改截至日期
      async changeEndDate() {
        // 转换日期为字符串
        var year = this.endDate.getFullYear(); //年
        var month = this.endDate.getMonth(); //月
        var day = this.endDate.getDate(); //日
        this.endDate = year + "-" + ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" + (day > 9 ? day : (
          "0" + day))

        console.log('date', this.endDate)

        let data = {}
        let resGet = await this.axios.get('/sysDic/?name=申报截至日期')
        if (resGet.status == 200) {
          // 表里有初始化数据
          if (resGet.data.results.length == 1) {
            data = resGet.data.results[0]
            data.value = this.endDate

            let resPut = await this.axios.put(`/sysDic/${data.id}/`, data)
            if (resPut.status == 200) {
              return this.$message.success('修改日期成功！')
            }
          }
          //   表里没有初始化数据
          else {
            data = {
              name: '申报截至日期',
              value: this.endDate,
              desc: '用于验证申报人是否在此日期前超龄'
            }
            let resPost = await this.axios.post('/sysDic/', data)
            if (resPost.status == 200) {
              return this.$message.success('新增日期成功')
            } else {
              console.log('error', resPost)
            }
          }
        }
      },

      //研究计划字数限制
      async changeTotalWrods() {
        let data = {}
        let resGet = await this.axios.get('/sysDic/?name=研究计划字数限制')
        if (resGet.status == 200) {
          // 表里有初始化数据
          if (resGet.data.results.length == 1) {
            data = resGet.data.results[0]
            data.value = this.TotalWrods

            let resPut = await this.axios.put(`/sysDic/${data.id}/`, data)
            if (resPut.status == 200) {
              return this.$message.success('修改成功！')
            }
          }
          //   表里没有初始化数据
          else {
            data = {
              name: '研究计划字数限制',
              value: this.TotalWrods,
              desc: '填写申报书时，研究计划字数限制'
            }
            let resPost = await this.axios.post('/sysDic/', data)
            if (resPost.status == 200) {
              return this.$message.success('新增成功')
            } else {
              console.log('error', resPost)
            }
          }
        }
      }
    },
  }

</script>

<style lang="less" scoped>
  .el-card {
    height: 100%;
    margin-top: 15px;
  }

  .row-search {
    margin-top: 20px;
  }

  .user-search {
    width: 420px;
  }

  .el-pagination {
    margin-top: 15px;
  }

  .el-col-user-add {
    display: flex;
  }

  .bt-user-add {
    margin-left: 10px;
  }

  .div-file {
    margin-top: 15px;

    .div-upload {
      height: 47px;

      .input-upload {
        width: 73px;
        height: 33px;
        position: absolute;
        z-index: 1;
        opacity: 0;
      }

      .button-upload {
        position: absolute;
      }

      .button-upload:hover {
        cursor: pointer;
      }
    }
  }

  .demo-table-expand {
    font-size: 0;

    label {
      width: 90px;
      color: #99a9bf;
    }

    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/SysDic.vue